import {
  FlexCenter,
  SkeletonBlock,
  TableHeader,
  TableHeaderCell,
  TextBody,
  TextLabel,
} from "@opensea/ui-kit"
import { StacksFilled } from "@opensea/ui-kit/icons"
import { useMemo } from "react"
import { useTranslations } from "use-intl"
import { LISTINGS_FLOW_ITEMS_TABLE_CLASSNAMES } from "./constants"
import { IncrementAllPricesInput } from "./IncrementAllPricesInput"

type Props = {
  numItems: number
  isReview: boolean
  adjustForFees?: boolean
  skeleton?: boolean
}

export const ListingFlowItemsTableHeader = ({
  numItems,
  isReview,
  adjustForFees = false,
  skeleton,
}: Props) => {
  const t = useTranslations("wallet.ListingFlowItemsTableHeader")
  const priceCell = useMemo(() => {
    if (numItems === 1 || isReview) {
      return (
        <TextLabel size="2xs">
          {adjustForFees ? t("proceeds") : t("listedAs")}
        </TextLabel>
      )
    }

    if (skeleton) {
      return <SkeletonBlock className="h-8 w-[90px]" />
    }

    return <IncrementAllPricesInput />
  }, [isReview, adjustForFees, numItems, skeleton, t])

  return (
    <TableHeader className="min-h-10 overflow-visible bg-transparent">
      <TableHeaderCell className={LISTINGS_FLOW_ITEMS_TABLE_CLASSNAMES.item}>
        <FlexCenter className="gap-2">
          <StacksFilled size={16} />
          <TextBody className="font-sans lowercase">
            {numItems} {numItems === 1 ? t("item") : t("items")}
          </TextBody>
        </FlexCenter>
      </TableHeaderCell>
      <TableHeaderCell className={LISTINGS_FLOW_ITEMS_TABLE_CLASSNAMES.floor}>
        <TextLabel size="2xs">{t("floor")}</TextLabel>
      </TableHeaderCell>
      <TableHeaderCell
        className={LISTINGS_FLOW_ITEMS_TABLE_CLASSNAMES.traitFloor}
      >
        <TextLabel size="2xs">{t("traitFloor")}</TextLabel>
      </TableHeaderCell>
      <TableHeaderCell
        className={LISTINGS_FLOW_ITEMS_TABLE_CLASSNAMES.topOffer}
      >
        <TextLabel size="2xs">{t("topOffer")}</TextLabel>
      </TableHeaderCell>
      <TableHeaderCell className={LISTINGS_FLOW_ITEMS_TABLE_CLASSNAMES.cost}>
        <TextLabel size="2xs">{t("cost")}</TextLabel>
      </TableHeaderCell>
      <TableHeaderCell
        className={LISTINGS_FLOW_ITEMS_TABLE_CLASSNAMES.proceeds}
      >
        <TextLabel size="2xs">
          {adjustForFees ? t("listedAs") : t("proceeds")}
        </TextLabel>
      </TableHeaderCell>
      <TableHeaderCell className={LISTINGS_FLOW_ITEMS_TABLE_CLASSNAMES.price}>
        {priceCell}
      </TableHeaderCell>
      {numItems > 1 && !isReview && (
        <TableHeaderCell
          className={LISTINGS_FLOW_ITEMS_TABLE_CLASSNAMES.remove}
        />
      )}
    </TableHeader>
  )
}
